<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="up" icon="up" bold :text="lang.button_Up" :tooltip="lang.button_Up"
            :disabled="upButtonStatus" />

          <action-button v-show="tabStatus!=3" v-if="isOwner && bomDetails.isCore && appConf.status.isBasicBundle == false"
            @click="createBomPart" icon="new" bold :text="lang.button_CreateBomPart"
            :tooltip="lang.button_CreateBomPart" :disabled="createBomPartButtonStatus" />

          <action-button v-show="tabStatus!=3" v-if="isOwner && bomDetails.isCore && appConf.status.isBasicBundle == false"
            @click="updateBomPart" icon="edit" bold :text="lang.button_UpdateBomPart"
            :tooltip="lang.button_UpdateBomPart" :disabled="updateBomPartButtonStatus" />

          <action-button v-show="tabStatus!=3" v-if="isOwner && bomDetails.isCore && appConf.status.isBasicBundle == false"
            @click="deleteBomPart" icon="remove" bold :text="lang.button_DeleteBomPart"
            :tooltip="lang.button_DeleteBomPart" :disabled="deleteBomPartButtonStatus" />

          <action-button v-show="tabStatus!=3" v-if="isOwner && !bomDetails.isCore && appConf.status.isBasicBundle == false"
            @click="setAlternative" icon="edit" bold :text="lang.button_SetAlternative"
            :tooltip="lang.button_SetAlternative" :disabled="setAlternativeButtonStatus" />

          <action-button v-show="tabStatus!=3"
            v-if="isOwner && !bomDetails.isCore && isPresent && appConf.status.isBasicBundle == false" @click="setNotPresent"
            icon="remove" bold :text="lang.button_SetNotPresent" :tooltip="lang.button_SetNotPresent"
            :disabled="setNotPresentButtonStatus" />

          <action-button v-show="tabStatus!=3"
            v-if="isOwner && !bomDetails.isCore && !isPresent && appConf.status.isBasicBundle == false" @click="setNotPresent"
            icon="new" bold :text="lang.button_SetPresent" :tooltip="lang.button_SetPresent"
            :disabled="setPresentButtonStatus" />

          <!-- <action-button v-show="tabStatus == 0" @click="importBom" icon="import" bold :text="lang.button_ImportBom" :tooltip="lang.button_ImportBom" :disabled="importBomButtonStatus"/>
          <action-button v-show="tabStatus == 0" @click="importIPC" icon="import" bold :text="lang.button_ImportIPC" :tooltip="lang.button_ImportIPC" :disabled="importIPCButtonStatus"/> -->

          <!-- <action-button @click="partDetails" icon="details-part" bold :text="lang.button_PartDetails" :tooltip="lang.button_PartDetails" :disabled="partDetailsButtonStatus"/> -->
          <!-- <action-button v-show="tabStatus == 3" @click="importDocument" icon="import" bold :text="lang.button_ImportDocument" :tooltip="lang.button_ImportDocument" :disabled="importDocumentButtonStatus"/>
          <action-button v-show="tabStatus == 3" @click="downloadDocument" icon="download" bold :text="lang.button_DownloadDocument" :tooltip="lang.button_DownloadDocument" :disabled="downloadDocumentButtonStatus"/> -->
          <!-- <action-button  @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save" :disabled="saveButtonStatus"/> -->




        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>

        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'

  import Content from "@/components/ProjectManager/Views/ProjectBom/Middle/Content/Content"
  import { mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props:{
    lang: Object
  },
  data () {
    return {
      importBomButtonStatus: false,
      createBomPartButtonStatus: false,
      updateBomPartButtonStatus: true,
      deleteBomPartButtonStatus: true,
      setAlternativeButtonStatus: true,
      setNotPresentButtonStatus: true,
      setPresentButtonStatus: true,
      // partDetailsButtonStatus: false,
      // importDocumentButtonStatus: false,
      // downloadDocumentButtonStatus: true,
      // importIPCButtonStatus: false,
      backButtonStatus: false,
      upButtonStatus: false,
      tabStatus: 0,

    }
  },
  computed: {
     ...mapGetters({

      appConf: 'appConf',
    }),
    isBomInProject() {

      if (this.$store.getters.isBomInProject == true) {

        this.importBomButtonStatus = true;
      }
      return this.$store.getters.isBomInProject;
    },
    // selectedDocument() {
    //   return this.$store.getters.selectedDocument;
    // },
    selectedPart() {
      return this.$store.getters.selectedPartBomRow;
    },
    isPresent() {
      return this.$store.getters.selectedPartBomRow.isPresent;
    },
    isManual() {
      return this.$store.getters.selectedPartBomRow.isManual;
    },
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return;
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    isOwner() {
      if (this.lastRevisionHistory == undefined) {
        return false;
      }


      if (this.lastRevisionHistory.userId == this.$store.getters.currentUser.userId && this.lastRevisionHistory.status.display == "pending") {
        return true;
      }
      return false;
    },
    bomDetails() {

      return this.$store.getters.bomDetails;
    },

  },
  created() {


  },
  watch: {

    isBomInProject: function(newVal, oldVal){

      this.importBomButtonStatus = newVal;
    },

    selectedPart: function (newVal, oldVal) {

      if (Object.keys(newVal).length === 0) {
        this.updateBomPartButtonStatus = true;
      } else {
        if (newVal.status != "synchronized") {
          this.updateBomPartButtonStatus = false;
        } else {
          this.updateBomPartButtonStatus = true;
        }
      }
      if (Object.keys(newVal).length === 0) {
        this.deleteBomPartButtonStatus = true;
      } else {

        if (newVal.isManual == true) {
          this.deleteBomPartButtonStatus = false;
        } else {
          this.deleteBomPartButtonStatus = true;
        }

      }
      if (Object.keys(newVal).length === 0) {
        this.setAlternativeButtonStatus = true;
      } else {
        this.setAlternativeButtonStatus = false;
      }
      if (Object.keys(newVal).length === 0) {
        this.setNotPresentButtonStatus = true;
      } else {
        this.setNotPresentButtonStatus = false;
      }
      if (Object.keys(newVal).length === 0) {
        this.setPresentButtonStatus = true;
      } else {
        this.setPresentButtonStatus = false;
      }


    }


  },

  methods: {

    setIsCore(arg) {
      //this.isCore = arg;

    },
    switchButtons(index){

      this.tabStatus = index;
    },
    createBomPart() {


      let vue = this;

      let funcYes = function (e) {


        let form = vue.$store.getters.bomPartObjectForm;



        const obj = {
          bomId: vue.$store.getters.selectedBomRow[0].bomId,
          partNumber: form.partNumber,
          revision: form.revision,
          partReference: form.partReference,
          remarks: form.remarks
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_createNewBomPart", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {


                //reload tables
                if (vue.tabStatus == 0) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 1) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsMPNApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsMPNAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 2) {
                  let reloadObj = {
                    status: true,
                    name: "BomExtendedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomExtendedAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }


                let obj = {
                  text: vue.lang.alert_success_CreateBomPart,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_CreateBomPart,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              let obj = {
                text: vue.lang.alert_error_CreateBomPart + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      let obj = {

        text: "",
        type: "bompartform",
        buttons: 2,
        size: "lm",
        data: {
          source: "new"
        },
        lang: this.lang.modal_BomPartNewObjectForm,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

    },
    updateBomPart() {


      let vue = this;


      let form = {
        partNumber: vue.$store.getters.selectedPartBomRow.PartNumber,
        revision: vue.$store.getters.selectedPartBomRow.Revision,
        partReference: vue.$store.getters.selectedPartBomRow.PartReference,
        description: vue.$store.getters.selectedPartBomRow.Description,
        remarks: vue.$store.getters.selectedPartBomRow.Remarks,
        isManual: vue.$store.getters.selectedPartBomRow.isManual
      }


      let funcYes = function (e) {


        let form = vue.$store.getters.bomPartObjectForm;

        let obj = {};
        let method = "";

        if (vue.$store.getters.selectedPartBomRow.bomPartId === undefined || vue.$store.getters.selectedPartBomRow.bomPartId === null) {
          obj = {
            bomId: vue.$store.getters.selectedBomRow[0].bomId,
            partNumber: form.partNumber,
            revision: form.revision,
            partReference: form.partReference,
            description: form.description,
            remarks: form.remarks,
            isManual: form.isManual
          }
          method = "_updateBomPartAggregated"
        } else {
          obj = {
            bomPartId: vue.$store.getters.selectedPartBomRow.bomPartId,
            partNumber: form.partNumber,
            revision: form.revision,
            partReference: form.partReference,
            description: form.description,
            remarks: form.remarks,
            isManual: form.isManual
          }
          method = "_updateBomPart"
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + method, obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {



                //reload tables
                if (vue.tabStatus == 0) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 1) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsMPNApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsMPNAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 2) {
                  let reloadObj = {
                    status: true,
                    name: "BomExtendedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomExtendedAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                // vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                // reloadObj = {
                //   status: true,
                //   name: "UsedLibrariesInBomComponent"
                // }
                // vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                let obj = {
                  text: vue.lang.alert_success_UpdateBomPart,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_UpdateBomPart,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              let obj = {
                text: vue.lang.alert_error_UpdateBomPart + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      let obj = {

        text: "",
        type: "bompartform",
        buttons: 2,
        size: "lm",
        data: {
          source: "update",
          form: form
        },
        lang: this.lang.modal_BomPartUpdateObjectForm,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);
    },
    deleteBomPart() {


      let vue = this;

      let deleteFunc = function () {



        let obj = {};
        let method = "";

        if (vue.$store.getters.selectedPartBomRow.bomPartId === undefined || vue.$store.getters.selectedPartBomRow.bomPartId === null) {

          let form = vue.$store.getters.bomPartObjectForm;
          obj = {
            bomId: vue.$store.getters.selectedBomRow[0].bomId,
            partNumber: vue.$store.getters.selectedPartBomRow.PartNumber,
            revision: vue.$store.getters.selectedPartBomRow.Revision,
            partReference: vue.$store.getters.selectedPartBomRow.PartReference,
            description: vue.$store.getters.selectedPartBomRow.Description,
            remarks: vue.$store.getters.selectedPartBomRow.Remarks,
            isManual: vue.$store.getters.selectedPartBomRow.isManual
          }
          method = "_deleteBomPartAggregated";
        } else {
          obj = {
            bomPartId: vue.$store.getters.selectedPartBomRow.bomPartId,

          }
          method = "_deleteBomPart";
        }


        vue.$store.dispatch(vue.$store.getters.sectionPrefix + method, obj)
        .then(function (result) {

          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {



              //reload tables
              if (vue.tabStatus == 0) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 1) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsMPNApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsMPNAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 2) {
                  let reloadObj = {
                    status: true,
                    name: "BomExtendedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomExtendedAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }

              let obj = {
                text: vue.lang.alert_success_DeleteBomPart,
                time: 10,
                type: "success"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            } else {
              let obj = {
                text: vue.lang.alert_error_DeleteBomPart,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }
          } else {
            let obj = {
              text: vue.lang.alert_error_DeleteBomPart + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        })
      }

      const obj = {
        title: this.lang.alert_delete_title,
        text: this.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteFunc,
        funcNo: ""
      };
      this.$store.dispatch("showAlert", obj);
    },
    setAlternative() {

      let vue = this;


      let form = {
        partNumber: vue.$store.getters.selectedPartBomRow.PartNumber,
        revision: vue.$store.getters.selectedPartBomRow.Revision,
        partReference: vue.$store.getters.selectedPartBomRow.PartReference,
        description: vue.$store.getters.selectedPartBomRow.Description,
        remarks: vue.$store.getters.selectedPartBomRow.Remarks,
        isManual: vue.$store.getters.selectedPartBomRow.isManual
      }


      let funcYes = function (e) {


        let form = vue.$store.getters.bomPartObjectForm;

        let obj = {};
        let method = "";


        if (vue.$store.getters.selectedPartBomRow.bomPartId === undefined || vue.$store.getters.selectedPartBomRow.bomPartId === null) {
          obj = {
            bomId: vue.$store.getters.selectedBomRow[0].bomId,
            partNumber: form.partNumber,
            revision: form.revision,
            partReference: form.partReference,
            //description: form.description,
            remarks: form.remarks,
            //isManual: form.isManual
          }
          method = "_updateBomPartAggregated"
        } else {
          obj = {
            bomPartId: vue.$store.getters.selectedPartBomRow.bomPartId,
            partNumber: form.partNumber,
            revision: form.revision,
            partReference: form.partReference,
            //description: form.description,
            remarks: form.remarks,
            //isManual: form.isManual
          }
          method = "_updateBomPart"
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + method, obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {



                //reload tables
                if (vue.tabStatus == 0) {

                  let reloadObj = {
                    status: true,
                    name: "BomPartsApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 1) {

                  let reloadObj = {
                    status: true,
                    name: "BomPartsMPNApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsMPNAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 2) {

                  let reloadObj = {
                    status: true,
                    name: "BomExtendedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomExtendedAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }

                let obj = {
                  text: vue.lang.alert_success_SetAlternative,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_SetAlternative,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              let obj = {
                text: vue.lang.alert_error_SetAlternative + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      let obj = {

        text: "",
        type: "bompartform",
        buttons: 2,
        size: "lm",
        data: {
          source: "update",
          form: form
        },
        lang: this.lang.modal_BomPartUpdateObjectForm,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

    },
    setNotPresent() {

      let vue = this;

      let isPresent = vue.selectedPart.isPresent;

      let alert_success_isPresent = vue.lang.alert_success_SetNotPresent;
      let alert_error_isPresent = vue.lang.alert_error_SetNotPresent;
      if (isPresent == true) {
        alert_success_isPresent = vue.lang.alert_success_SetPresent;
        alert_error_isPresent = vue.lang.alert_error_SetPresent;
      }

      let obj = {};
      let method = "";




      if (vue.$store.getters.selectedPartBomRow.bomPartId === undefined || vue.$store.getters.selectedPartBomRow.bomPartId === null) {
        obj = {
          bomId: vue.$store.getters.selectedBomRow[0].bomId,
          partReference: vue.selectedPart.PartReference,

        }
        method = "_setNotPresentAggregated"
      } else {
        obj = {
          bomPartId: vue.$store.getters.selectedPartBomRow.bomPartId,
        }
        method = "_setNotPresent"
      }

      vue.$store.dispatch(vue.$store.getters.sectionPrefix + method, obj)
        .then(function (result) {

          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {



              //reload tables
              if (vue.tabStatus == 0) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 1) {
                  let reloadObj = {
                    status: true,
                    name: "BomPartsMPNApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomPartsMPNAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }
                if (vue.tabStatus == 2) {
                  let reloadObj = {
                    status: true,
                    name: "BomExtendedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                  reloadObj = {
                    status: true,
                    name: "BomExtendedAggregatedApiFilteredComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }

              let obj = {
                text: alert_success_isPresent,
                time: 10,
                type: "success"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            } else {
              let obj = {
                text: alert_error_isPresent,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }
          } else {
            let obj = {
              text: alert_error_isPresent + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        })

    },
    setPresent() {

    },
    up() {

      this.$store.commit("RESETROUTINGDATA");

      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");



      let to = "/ProjectManager/ProjectDetails";

      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id,
        end: false,
        //bomId: this.$store.getters.selectedBomRow[0].bomId
      }

      this.$store.commit("FORWARDROUTINGDATA", routingObject)


      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: this.$route.query.sourceRevisionId,
      //   id: this.$route.query.sourceId,
      //   end: false
      // }

      this.$router.push({ path: to, query: routingObject });

    },
    back() {
      //#####################################################################
      let query = {};
      let to = "";

      if (this.$store.getters.routingData.length == 0) {
        if (this.$store.getters.sectionPrefix == "pm") {
          to = "/PartManager/PartTable";
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          to = "/LibraryManager/LibraryTable";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          if (this.$route.path == "ProjectManager/ProjectBom") {
            to = "/ProjectManager/ProjectDetails";
          } else {
            to = "/ProjectManager/ProjectTable";
          }

        }


      } else {
        to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].from;
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end == true) {
          if (this.$store.getters.sectionPrefix == "pm") {
            to = "/PartManager/PartTable";
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            to = "/LibraryManager/LibraryTable";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            if (this.$route.path == "ProjectManager/ProjectBom") {
              to = "/ProjectManager/ProjectDetails";
            } else {
              to = "/ProjectManager/ProjectTable";
            }
          }

        }

        query = {
          from: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to,
          to: to,
          end: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end,
          revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
          id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId
        }
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "main") {
          query = {};
        } else if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "details") {
          const goalObj = {
            to: to,
            revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
            id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
            selectedBomRow: [{ bomId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId }],

          }
          this.selectRow(goalObj);
        }

        this.$store.commit("BACKROUTINGDATA");
      }



      this.$router.push({ path: to, query: query })

    },
    selectRow(goalObj) {


      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)

      let obj = {};

      if (goalObj.to == "/PartManager/PartDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/ProjectManager/ProjectDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }




      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);
    },
    back2() {

      let to = "/ProjectManager/ProjectDetails";




      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id,

      }

      this.$router.push({ path: to, query: query });

    },
    toggleRightPanel(){

      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;

    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>
  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectBom/Middle/Middle.vue